import { render, staticRenderFns } from "./NotInstance.vue?vue&type=template&id=7d80e610&"
import script from "./NotInstance.vue?vue&type=script&lang=js&"
export * from "./NotInstance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports